import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
export class TraitRegistryDesignBox extends TraitRegistryCategory {
    label = 'Rahmen';
    constructor(parent) {
        super(parent);
        super.init();
    }
    designBorder = () => new TraitTypeSelectWithPreview({
        stylesheet: () => '/lib/cssStyles/border.css',
        classNames: ({ at }) => [at.trait.value]
    });
    designBoxShadow = () => new TraitTypeSelectWithPreview({
        stylesheet: () => '/lib/cssStyles/boxshadow.css',
        classNames: ({ at }) => [at.trait.value]
    });
    designImageShadow = () => new TraitTypeSelectWithPreview({
        stylesheet: () => '/lib/cssStyles/imageshadow.css',
        classNames: ({ at }) => [
            at.trait.value
        ] /*
        label: 'Bildrahmenvorlage',
        select: ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10'].map(k => [k]) as [string][] */
    });
}
